import React, { useState } from 'react';
import WeeklyEngagementChart from './WeeklyEngagementChart';
import CustomersDonut from './CustomersDonut';
import PerformanceTable from './PerformanceTable';

const AnalyticsDashboard = () => {
  const [selectedMonth, setSelectedMonth] = useState('October');
  
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center space-y-4 lg:space-y-0">
        <div>
          <h1 className="text-3xl font-bold text-[#FFFFFF]">Analytics Dashboard</h1>
          <p className="text-[#B0B0B0] mt-1">Comprehensive insights into your portfolio performance</p>
        </div>
        <div className="flex items-center space-x-4">
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="px-4 py-3 bg-[#2A2A2A] border border-[#3A3A3A] rounded-lg text-[#FFFFFF] focus:outline-none focus:border-[#B4E50D] focus:ring-2 focus:ring-[#B4E50D] focus:ring-opacity-20 transition-all duration-200"
          >
            {months.map(month => (
              <option key={month} value={month} className="bg-[#2A2A2A] text-[#FFFFFF]">{month}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="bg-[#1A1A1A] rounded-xl p-6 shadow-xl border border-[#2A2A2A] hover:border-[#B4E50D] transition-all duration-300">
        <h2 className="text-xl font-semibold mb-4 text-[#FFFFFF]">Weekly Engagement Trends</h2>
        <WeeklyEngagementChart />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-[#1A1A1A] rounded-xl p-6 shadow-xl border border-[#2A2A2A] hover:border-[#B4E50D] transition-all duration-300">
          <h2 className="text-xl font-semibold mb-4 text-[#FFFFFF]">Customer Distribution</h2>
          <CustomersDonut />
        </div>
        
        <div className="bg-[#1A1A1A] rounded-xl p-6 shadow-xl border border-[#2A2A2A] hover:border-[#B4E50D] transition-all duration-300">
          <h2 className="text-xl font-semibold mb-4 text-[#FFFFFF]">Performance Comparison</h2>
          <PerformanceTable />
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;